import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Box } from 'reactjs-admin-lte'
import { Popover, OverlayTrigger, Button, ButtonToolbar, ControlLabel, InputGroup, FormGroup, Row, Col, FormControl, Modal, Form } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import PettycashDocStore from '../../stores/PettycashDocStore'
import WorkdocStore from '../../stores/WorkdocStore'
import DatePicker from '../../component/element/DatePicker'
import ConfirmPopup from '../../component/element/ConfirmPopup'
import InputNumber from 'rc-input-number';
import SWTNewCustomerModal from '../workdoc/SWTNewCustomerModal'
import CKAutocomplete from '../../component/element/CKAutocomplete'
import SearchJob from 'component/element/SearchJob'
import { Checkbox } from 'react-icheck';
import Moment from 'moment'
const yTh = parseInt(Moment().format('YYYY')) + 543
const create_date = Moment().format('L LT').replace(Moment().format('YYYY'), yTh);
const NotificationSystem = require('react-notification-system');
const DEFAULT_ROW = 10

class PettyCashDoc extends Component {

  constructor(...args) {
    super(...args)
    this.state = this.initState()
    this.pcInput = new Array(DEFAULT_ROW).fill('')
  }

  initState(newState) {
    let state = {
      loading:false,
      showSaveEror:false,
      showReceive:false,
      indexReceived:-1,
      show:false,
      data:this.newEmptyRow(DEFAULT_ROW),
      options:[],
      doc:this.getEmptyDoc(),
      due_date:'',
      isDelivery:false,
      receivedCheckAll:false,
      receiveCheck:[],
      received_doc:{date:create_date,response_by:'',request_by:'',description:'',barcode:'',deliveryslip_no:'',taxinvoice_no:''},
      received_itemlist:[],
      valid:{request_by:{id:null,state:null,has_error:''},response_by:{id:null,state:null,has_error:''}},
      customerList:[],
      stockApproverList:[],
      barcodeMsg:'',
      barcodeMsgColor:'' 
    }

    if (newState !== undefined) {
      state = Object.assign(state, newState)
    }
    return state
  }

  componentDidMount() {

    //this.loadData(poNo)
  }

  loadWorkdocAutocompleteOfficer() {
    let that = this
    let officer = []
    WorkdocStore.loadWorkdocAutocompleteOfficer(function(result){
      result.data.forEach(element => {
        officer.push({
          id: element.Value,
          label: element.Name,
          emp_id: element.employee_id
        })
      });
      that.setState({customerList:officer})
    })  
  }

  loadWorkdocAutocompleteStockApprover() {
    let approver = []
    WorkdocStore.loadWorkdocAutocompleteStockApprover((result)=> {
      result.data.forEach(element => {
        approver.push({
          id: element.Value,
          label: element.Name
        })
      });
      this.setState({stockApproverList:approver})
    })  
  }
  
  renameDoc(newPettycashNo) {
    let { doc } = this.state
    doc['pettycash_no'] = newPettycashNo
    this.setState({ pettycashNo: newPettycashNo, doc: doc })
  }

  newEmptyRow(number) {
    return new Array(number).fill(null).map((item, index) => {
      return { bf_pettycash_item_id:'', pettycash_no:'', pettycash_name:'', seq:'', itemnum:'',  detail:'', quantity:'', price_per_unit:'', amount:'', work_no:'', car_registration_no:'' }
    })
  }

  getEmptyDoc() {
    return { added_date:'', amount: '', created_by:'', department:'', last_by:'', pettycash_no:'', remark:'', request_by: '', seq_no:'', status:'0', trash_flag:'0' }
  }

  getNumberCommas(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getValid(value) {
    value = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    return parseFloat(value)
  }
  
  loadNewDoc(callback) {
    let that = this
    this.setState(this.initState({ loading: true }))
    PettycashDocStore.newPettycashDoc((result)=> {
      let data = that.newEmptyRow(DEFAULT_ROW)
      this.setState({ loading: false, pettycashNo: result.data.doc.pettycash_no, doc: result.data.doc, data: data })
      if (callback !== undefined) {
        callback(result.data.doc)
      }
    },()=>{
      this.setState({loading:false})
    })
  }

  loadData(pettycashNo) {
    let that = this
    this.setState(this.initState({ loading: true, pettycashNo: pettycashNo }))
    PettycashDocStore.loadPettycashDoc(pettycashNo,  (result)=> {
      let data = result.data.itemlist
      data = data.map((item,index)=>{
        item = Object.assign(item,{pettycash_name:''})
        return item
      })
      if (result.data.itemlist.length < DEFAULT_ROW) {
        data = data.concat(that.newEmptyRow(DEFAULT_ROW - result.data.itemlist.length))
      }
      this.setState({ loading: false, doc: result.data.doc, data: data })  
    },()=>{
      this.setState({loading:false})
    })
  } 

  onPrintClick() {
    let {pettycash_no} = this.state.doc
    this.savePODoc(()=>{
      if (process.env.NODE_ENV == "development") {
        window.open('https://demo2.bigfix.co/korat/pdf/?po=' + pettycash_no + '&file=purchaseorder_doc', '_blank');
      } else {
        window.open('./pdf/?po=' + pettycash_no + '&file=purchaseorder_doc', '_blank');
      }
    })
  }

  onCustomerClick() {
    this.setState({ show: true })
  }

  onCustomerSelect(item) {
    let {doc} = this.state
    doc.request_by = item.name
    this.setState({doc:doc})
  }

  onInputChange(key, e) {
    let { doc } = this.state
    doc[key] = e.target.value
    this.setState({ doc: doc })
  }

  onDateChange(dateString, dateMoment) {
    let { doc } = this.state
    doc['added_date'] = dateString
    this.setState({ doc: doc })
  }

  onSaveClick() {
    this.savePODoc()
  }

  savePODoc(completeSaveFunc){
    let { doc, data, pettycashNo } = this.state
    this.setState({ loading: true })
      
    doc.amount = this.getNetTotal()  
    let postData = { pettycash_no: pettycashNo, doc: doc, itemlist: data}
    PettycashDocStore.savePettycashDoc(postData,  (result)=> {
      doc.seq_no = result.seq_no
      this.refs.notificationSystem.addNotification({
        title:'แจ้งเตือน',
        message:'บันทึกรายการสำเร็จ',
        level:'info',
        position:'tc'        
      });
      this.setState({ loading: false, doc: doc, data:data })
      if(completeSaveFunc!==undefined){
        completeSaveFunc()
      }
    },  (error)=> {
      this.setState({ loading: false, showSaveEror: true })
      this.refs.notificationSystem.addNotification({
        title:'แจ้งเตือน',
        message:'ไม่สามารถบันทึกรายการได้',
        level:'error',
        position:'tc'        
      });
    })
  }

  onSaveErrorConfirm() {
    this.onSaveClick()
  }

  onCloseClick() {

    if (this.props.onClose !== undefined) {
      this.props.onClose()
    }
  }

  onDeleteRowClick(index) {
    let { data } = this.state

    data.splice(index, 1);
    this.setState({ data: data })

  }

  onFormChange(index, key, e) {
    let { doc, data, discount_per } = this.state
    let value = e.target.value
    data[index][key] = value
   
    this.setState({ doc: doc, data: data, discount_per:discount_per })
  }

  onFormSelect(index, key, eitem) {
    let {data} = this.state
    if (key=='work_no') {
      // data[index]['car_registration_no'] = eitem.car_registration_no
      data[index]['work_no'] = eitem.work_no
    }
    this.setState({data:data})
  }

  onNumericChange(index, key, e) {
    let { doc, data, discount_per } = this.state
    let value = e
    data[index][key] = value
   
    this.setState({ doc: doc, data: data, discount_per:discount_per })
  }

  onRowAdd(number) {
    let { data } = this.state


    data = data.concat(this.newEmptyRow(number))

    this.pcInput = new Array(data.length).fill('')
    this.setState({ data: data })
  }



  onTypeaheadInputChange(index,query){
    //console.log('typeChagne',e,text)
    //console.log("query",query)
    let {data} = this.state
    data[index]['detail'] = query
    
    
    this.setState({data:data})
  }

  onTypeaheadChange(index, option) {
    //console.log('options', index, option)

    let { data } = this.state
    if (option.length === 1) {

      data[index].detail = option[0].detail
      data[index].quantity = 1
      if (option[0].itemnum !== undefined) {
        data[index].itemnum = option[0].itemnum
        data[index].productcode = option[0].productCode
      }
    }
    this.setState({ data: data })
  }

  onSearchCarKeyPress(e) {
    if (e.charCode == 13) {
      //console.log('enter',e.target.value)
      let {doc} = this.state
    }
      
  }


  onSearchKeyPress(index, key, target) {
    if (target.charCode == 13) {
      let { data } = this.state
      //console.log("code enter", data[index])
      let that = this, foundIndex = -1
      //let options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
      this.setState({ loading: false })
      let productCode = data[index][key];
      data.map((item, iindex) => {
        if (item.productcode === productCode && iindex !== index) {
          foundIndex = iindex
        }
      })
      if (foundIndex >= 0) {
        data[foundIndex].quantity = data[foundIndex].quantity * 1 + 1
        data[index].productcode = ''
        that.setState({ loading: false, data: data, rowBeep: foundIndex })
        setTimeout(function () {
          that.setState({ rowBeep: -1 })
        }, 1500);
      } else {
        
      }
    }
  }

  getShopIdValidState() {
    if (this.state.showReportWorkHit && this.state.doc.shop_id === null) {
      return 'error'
    }

  }

  getValidationState() {
    // const length = this.state.shopName.length;
    // if (length > 10) return 'success';
    // else if (length > 5) return 'warning';
    // else if (length > 0) return 'error';
  }

  _renderMenuItemChildren(option, props, index) {
    if (option.pricePerUnit > 0) {
      return (
        <div key={option.id}>
          <span>{option.detail} (หมวด{option.categoryName}) - {option.pricePerUnit} บาท</span>
        </div>
      );
    } else {
      return (
        <div key={option.id}>
          <span>{option.detail}</span>
        </div>
      );
    }
  }

  renderHeaderRow() {
    let { request_by,department, added_date, pettycash_no } = this.state.doc
    if (typeof added_date === 'undefined') return null
    return (
      <div>
        <Row>
          <Col md={3}>
            <FormGroup
              controlId="formBasicText"
              validationState={this.getShopIdValidState()}
            >
              <ControlLabel>จ่าย :</ControlLabel>
              <InputGroup>
                <InputGroup.Addon><FontAwesome name='user' /></InputGroup.Addon>
                <FormControl value={request_by} onChange={this.onInputChange.bind(this, 'request_by')} />
                <InputGroup.Addon onClick={this.onCustomerClick.bind(this)}><FontAwesome name='plus' /></InputGroup.Addon>
              </InputGroup>
            </FormGroup>
          </Col>
          <Col md={5}>
            <FormGroup
              controlId="formBasicText"
              validationState={this.getValidationState()}
            >
              <ControlLabel>ฝ่าย :</ControlLabel>
              <InputGroup>
                <InputGroup.Addon><FontAwesome name='location-arrow' /></InputGroup.Addon>
                <FormControl value={department} onChange={this.onInputChange.bind(this, 'department')} />
              </InputGroup>
            </FormGroup>
          </Col>
          <Col md={2}>
            <FormGroup
              controlId="formBasicText"
              validationState={this.getValidationState()}
            >
              <ControlLabel>เลขที่ :</ControlLabel>
              <InputGroup>
                <InputGroup.Addon><FontAwesome name='file-o' /></InputGroup.Addon>
                <FormControl value={pettycash_no} onChange={()=>{}} readOnly={true} />
              </InputGroup>
            </FormGroup>
          </Col>    
          <Col md={2}>
            <FormGroup
              controlId="formBasicText"
              validationState={this.getValidationState()}
            >
              <ControlLabel>วันที่ :</ControlLabel>
              <DatePicker style={{ display: 'inline-block' }}
                  ref={(ele) => { this.datePicker = ele }}
                  showIcon={true}
                  showFooter={true}
                  popPlacement='bottom'
                  buddhistEra
                  value={added_date}
                  onChange={this.onDateChange.bind(this)}
                  maxWidth={'100%'}
                />
            </FormGroup>
          </Col>
        </Row>
    </div>
    )
  }

  getDueDate() {
    let {doc} = this.state

    if (isNaN(doc.credit_day)||doc.credit_day==='0') {
      return ''
    }

    let added_date_y = doc.added_date.substring(6, 10)
    let added_date_m = doc.added_date.substring(3, 5)
    let added_date_d = doc.added_date.substring(0, 2)
    let added_date_new = added_date_y+'/'+added_date_m+'/'+added_date_d

    let date = new Date(added_date_new)
    let newdate = new Date(date)
    newdate.setDate(newdate.getDate() + (parseInt(doc.credit_day) + parseInt(1)))
    
    let dd = newdate.getDate()
    let mm = newdate.getMonth() + parseInt(1)
    let y = newdate.getFullYear()

    if (!isNaN(dd)&&!isNaN(mm)&&!isNaN(y)) {
      if (mm<10) {
        mm = '0'+mm
      }
      if (dd<10) {
        dd = '0'+dd
      }
      return dd+'/'+mm+'/'+y
    }
    return ''
  }

  renderRemark() {
    let { remark } = this.state.doc
    return (
      <Row style={{marginTop:'10px'}}>
        <Col md={3}>
          <FormGroup
            controlId="formBasicText"
            validationState={this.getValidationState()}
          >
            <ControlLabel>หมายเหตุ </ControlLabel>
              <FormControl value={remark} componentClass="textarea" style={{ width: '100%', height: '150px' }} onChange={this.onInputChange.bind(this, 'remark')} />
          </FormGroup>
        </Col>
        
      </Row>
    )
  }

  getRowClassName(item, index) {
    let { rowBeep } = this.state
    let className = (item.itemnum > 0) ? '' : (item.detail.length > 0) ? 'bg-gray' : ''

    if (rowBeep === index) {
      className = 'bg-yellow'
    }
    return className
  }

  renderWorkNo(workNo) {
    if (typeof workNo === 'undefined' || workNo === '') return null
    const title = 'ใบงานซ่อม ' + workNo
    const popoverRight = (
      <Popover id="popover-trigger-hover-focus" title={title}>
        <strong>คลิกตรงไอค่อนเพื่อเข้าดูใบงาน</strong>
      </Popover>
    )
    return (
      <span>
        {workNo + ' '}
        <OverlayTrigger
          trigger={['hover', 'focus']}
          placement="right"
          overlay={popoverRight}
        >
          <FontAwesome className="text-blue" name='file-text-o' />
        </OverlayTrigger>
      </span>
    )
  }

  renderPartType(part_type){
    const partTypeMap = {originalPrice:"แท้",similarPrice:'เทียบ',oldPartPrice:'เก่า'}

    return partTypeMap[part_type]
  }

  onDiscountPercentSelect(index,key,e) {
    let {discount_per,data} = this.state
    discount_per[index] = e
    let dis = 0
    let amount = data[index]['quantity']*data[index]['price_per_unit']

    
    amount = (amount*data[index]['vat']/100) + amount
    

    dis = (amount*e) / 100
    data[index]['discount'] = dis.toFixed(2)
    data[index]['amount'] = amount - data[index]['discount']
    this.setState({discount_per:discount_per,data:data})
  }

  onColVatChange(index){
    let {data} = this.state
    
    if(data[index]['vat']*1===0)
      data[index]['vat'] = 7
    else
      data[index]['vat'] = 0

    this.setState({data:data})
  }

  onClearWorkNo(index) {
    let {data} = this.state
    data[index].work_no = ''
    this.setState({data:data})
  }

  onCarSearchSelect(index,e) {
    let {data} = this.state  
    // data[index]['car_registration_no'] = (typeof e.car_registration_no!=='undefined'?e.car_registration_no:e.Value)
    data[index]['work_no'] = e.work_no
    this.setState({data:data})
  }

  renderRowData() {
    let { data } = this.state
    if (data.length===0) {
      return(<tr><td colSpan={8}>ไม่พบข้อมูล</td></tr>)
    } else {
      return data.map((item, index) => (
        <tr key={index}>
          <td className='text-center'>{index + 1}</td>        
          <td>
            <FormControl value={item.detail} onChange={this.onFormChange.bind(this, index, 'detail')} />
          </td>        
          <td className='text-center'>
            {item.pettycash_no}
          </td>
          <td className='text-center'>
            <FormControl value={item.pettycash_name} onChange={this.onFormChange.bind(this, index, 'pettycash_name')} />
          </td>
          <td className='text-right'>
            <InputNumber
              className='input-number-format'
              value={item.price_per_unit} 
              onChange={this.onNumericChange.bind(this, index, 'price_per_unit')}
              formatter={value =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              }
            />
          </td>
          <td className='text-center'>
            <SearchJob
              ref={(input) => { this.pcInput[index] = input; }}
              value={item.work_no}
              // workNo={item.work_no}
              // onClearWorkNo={this.onClearWorkNo.bind(this,index)}
              onChange={this.onFormChange.bind(this, index, 'work_no')}
              onSelect={this.onFormSelect.bind(this, index, 'work_no')}
              onCarSearchSelect={this.onCarSearchSelect.bind(this, index)}
            />
          </td>
          <td className='text-center'>
            <Button onClick={this.onReceivedClick.bind(this,index)}>
              <FontAwesome className='text-green' name='check' />
            </Button>
          </td>
          <td className='text-center' onClick={this.onDeleteRowClick.bind(this,index)}><FontAwesome className='text-red' name='trash'/></td>
        </tr>
      ))
    }
  }

  getAmountPerRow(quantity,price_per_unit) {
    quantity = this.getValid(quantity)
    price_per_unit = this.getValid(price_per_unit)
    return quantity*price_per_unit
  }

  getSumAmount() {
    let {data} = this.state
    let sum = 0
    let that = this
    data.forEach(function(item,index) {
      sum += parseFloat(that.getAmountPerRow(item.quantity,item.price_per_unit))
    })
    return sum
  }

  getVat() {
    let {doc} = this.state
    let sum = 0
    if (doc.vat_type==='VAT_EXCLUDE')
      sum = (this.getSumAmount()*7) / 100
    else
      sum = 0
    return sum.toFixed(2)
  }

  getNetTotal() {
    let sum = 0
    sum = parseFloat(this.getSumAmount()) + parseFloat(this.getVat())
    return sum.toFixed(2)
  }

  onVatChange(value) {
    let {doc} = this.state
    if (value==='NON_VAT'||value===undefined)
      doc.vat_type = 'VAT_EXCLUDE'
    else
      doc.vat_type = 'NON_VAT'  
    
    this.setState({doc:doc})
  }

  renderTable() {
    return (
      <div className='table-responsive'>
        <table className='table table-bordered-solid' style={{marginBottom:'0'}}>
          <thead>
            <tr >
              <th className='text-center' style={{ width: '30px' }}>ลำดับ</th>
              <th style={{ width: '250px' }}>รายการ/คำอธิบาย</th>              
              <th className='text-center' style={{ width: '100px' }}>รหัสบัญชี</th>
              <th className='text-center' style={{ width: '150px' }}>ชื่อบัญชี</th>              
              <th className='text-center' style={{ width: '120px' }}>จำนวนเงิน</th>
              <th className='text-center' style={{ width: '100px' }}>เลขที่จ็อบ/ใบงาน</th>
              <th className='text-center' style={{ width: '50px' }}>รับของ</th>
              <th className='text-center' style={{ width: '30px' }}>ลบ</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={4} className='text-right'>รวมเป็นเงิน</th>
              <th className='text-right'>{this.getNumberFormat(this.getSumAmount())}</th>
              <th colSpan={3} className='text-right'></th>
            </tr>
          </tfoot>
        </table>
      </div>
    )
  }

  renderNewItemButton() {
    return (
      <div style={{ display: 'inline-flex' }}>
        <ButtonToolbar>
          <Button className='bg-olive' onClick={this.onRowAdd.bind(this, 1)}><FontAwesome name='plus' />&nbsp;เพิ่มรายการ</Button>
          <Button className='bg-olive' onClick={this.onRowAdd.bind(this, 10)}><FontAwesome name='plus' />&nbsp;เพิ่ม 10 รายการ</Button>
        </ButtonToolbar>
      </div>
    )
  }

  renderStatus() {
    let { doc } = this.state
    if (doc.status === '1') {
      return (<span className='label label-success'>อนุมัติแล้ว</span>)
    } else if (doc.status === '2') {
      return (<span className='label label-primary'>ได้รับของแล้ว</span>)
    } else if (doc.status==='3') {
      return (<span className="label label-success" >นำเข้าสต็อกเรียบร้อย</span>)
    } else if (doc.status==='4') {
      return (<span className="label label-success" >นำไปซ่อมแล้ว</span>)        
    } else {
      return (<span />)
    }

  }

  closeReportWorkModal() {
    this.setState({ showReportWork: false })
  }

  onRowWorkClick(workNo) {
    this.setState({ showReportWork: false })
    if (typeof this.state.doc.shop_id === 'undefined' && typeof workNo === 'undefined')
      return

    
  }

  onSavePartItemsClick(newPurChaseOrders) {
    let {doc} = this.state
    newPurChaseOrders.forEach(function(item,index) {
      if (item.amount===undefined)
        newPurChaseOrders[index] = Object.assign(newPurChaseOrders[index],{amount:0})
      if (item.vat===undefined)
        newPurChaseOrders[index] = Object.assign(newPurChaseOrders[index],{vat:0})
    })

    const numRow = 10
    const difNumRow = numRow - newPurChaseOrders.length
    if (difNumRow > 0) {
      const emptyItems = this.newEmptyRow(difNumRow)
      this.setState({
        showReportWork: false,
        data: newPurChaseOrders.concat(emptyItems)
      })
    } else {
      this.setState({
        showReportWork: false,
        data: newPurChaseOrders
      })
    }

    newPurChaseOrders.forEach(function(item,index) {
      doc.car_registration_no = item.car_registration_no
    })
  }

  onAfterReceivedClick(items) {
    let {data} = this.state
    let checkItemnum = []
    items.forEach(function(item,index) {
      checkItemnum.push(item.bf_purchase_order_item_id)
    })
    data.forEach(function(item,index) {
      if (checkItemnum.indexOf(item.bf_purchase_order_item_id)!==-1) {
        data[index].is_receiveditem = true
      }
    })
    this.setState({data:data})
    this.savePODoc()
  }

  onAfterExportWorkClick(items) {
    let {data} = this.state
    let checkItemnum = []
    items.forEach(function(item,index) {
      checkItemnum.push(item.bf_purchase_order_item_id)
    })
    data.forEach(function(item,index) {
      if (checkItemnum.indexOf(item.bf_purchase_order_item_id)!==-1) {
        data[index].is_exportwork = true
      }
    })
    this.setState({data:data})
    this.savePODoc()
  }

  onAfterReturnClick(items) {
    let {data} = this.state
    let checkItemnum = []
    items.forEach(function(item,index) {
      checkItemnum.push(item.bf_purchase_order_item_id)
    })
    checkItemnum.forEach(function(item,index) {
      data.splice(data.map(function(e) { return e.bf_purchase_order_item_id; }).indexOf(item), 1)
    })
    this.setState({data:data})
    this.savePODoc()
  }

  onReceivedClick(index) {
    this.setState({showReceived:true,indexReceived:index})
    this.loadWorkdocAutocompleteOfficer()
    this.loadWorkdocAutocompleteStockApprover()    
  }

  onReceivedHide() {
    this.setState({showReceived:false})
  }

  onReceivedPrintClick() {

  }

  onReceivedSaveClick() {

  }

  onReceivedTextChange(key,e) {
    let {received_doc,isDelivery} = this.state
    received_doc[key] = e.target.value
    if (isDelivery&&key==='deliveryslip_no')
      received_doc.taxinvoice_no = e.target.value
    this.setState({received_doc:received_doc})
  }

  onReceivedTextSelect(key,e) {
    let {received_doc} = this.state
    received_doc[key] = e
    this.setState({received_doc:received_doc})
    if (key==='request_by') {
      this.refs._response_by.onFocus()
    } else if (key==='response_by') {
      ReactDOM.findDOMNode(this.refs._description).focus()
    }
  }

  onDeliveryChange() {
    let {isDelivery,received_doc} = this.state
    isDelivery = isDelivery?false:true
    if (isDelivery)
      received_doc.taxinvoice_no = received_doc.deliveryslip_no
    this.setState({isDelivery:isDelivery,received_doc:received_doc})
  }

  onReceivedTextKeyPress(key,e) {
    if (e.charCode === 13) {
      e.preventDefault()

      let {customerList,received_doc} = this.state
      let checkSearch = false
      let value = ''

      customerList.forEach(function(item,index) {
        if (item.emp_id===e.target.value) {
          checkSearch = true
          value = item.id
        }
      })

      if (checkSearch) {
        if (key=='request_by') {
          received_doc[key] = value
          this.refs._response_by.onFocus()
        } else if (key=='response_by') {
          received_doc[key] = value
          ReactDOM.findDOMNode(this.refs._description).focus()
        }
      } else { 
        received_doc[key] = ''
        this.refs.notificationSystem.addNotification({
          title: 'แจ้งเตือน',
          message: 'ไม่พบรหัส ' + e.target.value + ' กรุณาลองใหม่',
          level: 'error',
          position: 'tc'
        });
      }  
      this.setState({received_doc:received_doc})
    }
  }

  onReceivedSearchKeyPress(e) {
    if (e.charCode===13) {
      let {received_doc} = this.state
      if (e.target.value!=='') {
        let checkBarcode = false
        let {received_itemlist,receiveCheck} = this.state
        let _items = []
        _items = received_itemlist
        _items.forEach(function(item,index) {
          if (item.seq!==undefined) { 
            if (item.productcode===e.target.value) {
              checkBarcode = true
              receiveCheck[index] = true
            }
          }  
        })
        let msg = ''
        let color = ''
        if (checkBarcode===true) {
          msg = 'รหัส '+e.target.value+' ตรวจสอบถูกต้อง'
          color = 'rgba(0, 166, 90, 0.67)'
        } else {
          msg = 'ไม่พบสินค้ารหัส '+e.target.value
          color = '#dd4b39'
        }
        received_doc.barcode = ''

        let isReceiveCheckAll = true
        receiveCheck.forEach(function(item,index) {
          if (!item)
            isReceiveCheckAll = false
        })
        this.setState({receiveCheck:receiveCheck,barcodeMsg:msg,barcodeMsgColor:color,received_doc:received_doc,receiveCheckAll:isReceiveCheckAll})
      }  
    }  
  }

  onReceivedChange(index,e) {
    let {receiveCheck,receiveCheckAll} = this.state
    let newReceiveCheck = []
    if (index==='all') {
      if (receiveCheckAll) {
        receiveCheck.forEach(function(item,index) {
          newReceiveCheck.push(false)
        })
        this.setState({receiveCheckAll:false,receiveCheck:newReceiveCheck})
      } else {
        receiveCheck.forEach(function(item,index) {
          newReceiveCheck.push(true)
        })
        this.setState({receiveCheckAll:true,receiveCheck:newReceiveCheck})
      }  
    } else {
      if (receiveCheck[index]) {
        receiveCheck[index] = false
        receiveCheckAll = false
      } else {
        receiveCheck[index] = true
        if (receiveCheck.indexOf(false)==-1)
          receiveCheckAll = true
      }
      this.setState({receiveCheck:receiveCheck,receiveCheckAll:receiveCheckAll})
    }  
  }

  renderReceivedDetail() {
    let {received_doc} = this.state
    return(
            <Form>
              <Row>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>เลขที่เอกสาร</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <FormControl placeholder="<เลขที่ถูกสร้างอัตโนมัติ>" className="input-dark" />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>วันที่<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <FormControl readOnly={true} placeholder="" className="input-dark" value={received_doc.date} />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={2}>
                  <FormGroup
                    controlId={this.state.valid.request_by.id}
                    validationState={this.state.valid.request_by.state}
                  >
                    <ControlLabel>ผู้รับสินค้า<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup
                    className={this.state.valid.request_by.has_error}
                    controlId={null}
                    validationState={null}
                  >
                    <CKAutocomplete
                      top={'-34px'}
                      items={this.state.customerList}
                      value={this.state.received_doc.request_by}
                      onChange={this.onReceivedTextChange.bind(this, 'request_by')}
                      onSelect={this.onReceivedTextSelect.bind(this, 'request_by')}
                      onKeyPress={this.onReceivedTextKeyPress.bind(this, 'request_by')}
                    />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup
                    controlId={this.state.valid.response_by.id}
                    validationState={this.state.valid.response_by.state}
                  >
                    <ControlLabel>ผู้อนุมัติ<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup
                    className={this.state.valid.response_by.has_error}
                    controlId={null}
                    validationState={null}
                  >
                    <CKAutocomplete
                      top={'-34px'}
                      items={this.state.customerList}
                      value={this.state.received_doc.response_by}
                      onChange={this.onReceivedTextChange.bind(this, 'response_by')}
                      onSelect={this.onReceivedTextSelect.bind(this, 'response_by')}
                      onKeyPress={this.onReceivedTextKeyPress.bind(this, 'response_by')}
                      ref='_response_by'
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>เลขที่ใบส่งของ</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <FormControl 
                      placeholder=""
                      value={ this.state.received_doc.deliveryslip_no } 
                      onChange={ this.onReceivedTextChange.bind(this, 'deliveryslip_no') }
                    />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>เลขที่ใบกำกับ</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup style={{marginBottom:'0'}}>
                    <Checkbox
                      onChange={this.onDeliveryChange.bind(this)}
                      checked={this.state.isDelivery}
                      checkboxClass="icheckbox_square-blue"
                      increaseArea="20%"
                      label=" เลขที่เดียวกับใบส่งของ"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControl 
                      placeholder=""
                      disabled={this.state.isDelivery}
                      value={ this.state.received_doc.taxinvoice_no } 
                      onChange={ this.onReceivedTextChange.bind(this, 'taxinvoice_no') }
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>คำอธิบาย</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <FormControl placeholder=""
                      value={ this.state.received_doc.description } onChange={ this.onReceivedTextChange.bind(this, 'description') } 
                      ref='_description'
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={2}>
                  <FormGroup
                    controlId={null}
                    validationState={null}
                  >
                    <ControlLabel>เช็คบาร์โค้ด</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup
                    controlId={null}
                    validationState={null}
                  >
                    <FormControl placeholder="" value={ this.state.received_doc.barcode }
                    onChange={ this.onReceivedTextChange.bind(this, 'barcode') } 
                    onKeyPress={this.onReceivedSearchKeyPress.bind(this)} />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <p style={{color:this.state.barcodeMsgColor}}>{this.state.barcodeMsg}</p>
                </Col>
              </Row>
            </Form>
    )
  }

  renderReceivedRowData() {
    let {received_itemlist} = this.state
    if (received_itemlist.length===0) {
      return(
        <tr><td colSpan={11}>ไม่พบข้อมูล</td></tr>
      )
    } else {

    }  
  }

  renderReceivedTable() {
    return(
      <div className="table-responsive">
        <table className="table table-hover table-bordered-solid">
          <thead>
            <tr>
              <th className='text-center' style={{width:'50px'}}>
                <Checkbox
                  onChange={this.onReceivedChange.bind(this,'all')}
                  checked={this.state.receiveCheckAll}
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"
                  label=""
                >
                </Checkbox>
              </th>
              <th className='text-center' style={{width:'50px'}}>ลำดับ</th>
              <th className='text-center' style={{width:'100px'}}>รหัสร้านค้า</th>
              <th className='text-center' style={{width:'120px'}}>ชื่อร้านค้า</th>
              <th className='text-center' style={{width:'100px'}}>รหัสอะไหล่</th>
              <th className='text-center' style={{width:'150px'}}>ชื่ออะไหล่</th>
              <th className='text-center' style={{width:'90px'}}>จำนวน</th>
              <th className='text-center' style={{width:'100px'}}>หน่วยละ</th>
              <th className='text-center' style={{width:'100px'}}>รวม</th>
              <th className='text-center' style={{width:'100px'}}>เข้าสโตร์</th>
              <th className='text-center' style={{width:'100px'}}>Shelf</th>
            </tr>
          </thead>
          <tbody>
            {this.renderReceivedRowData()}
          </tbody>
          <tfoot>
            <tr>
              <th className='text-center'>ทั้งหมด</th>
              <th className='text-center'>ลำดับ</th>
              <th className='text-center'>รหัสร้านค้า</th>
              <th className='text-center'>ชื่อร้านค้า</th>
              <th className='text-center'>รหัสอะไหล่</th>
              <th className='text-center'>ชื่ออะไหล่</th>
              <th className='text-center'>จำนวน</th>
              <th className='text-center'>หน่วยละ</th>
              <th className='text-center'>รวม</th>
              <th className='text-center'>เข้าสโตร์</th>
              <th className='text-center'>Shelf</th>
            </tr>
          </tfoot>
        </table>
      </div>  
    )
  }

  renderReceivedModal() {
    let {showReceived} = this.state
    return(
      <div>
        <Modal show={showReceived} onHide={this.onReceivedHide.bind(this)} dialogClassName="midwidth-dialog">
          <Modal.Header closeButton>
            <Modal.Title>เลือกรายการรับสินค้า</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.renderReceivedDetail()}
            {this.renderReceivedTable()}
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle={'danger'} onClick={this.onReceivedPrintClick.bind(this)}><FontAwesome name='print' />&nbsp;พิมพ์ใบรับสินค้า</Button>
            <Button bsStyle={'primary'} onClick={this.onReceivedSaveClick.bind(this)}><FontAwesome name='save' />&nbsp;บันทึกรับสินค้า</Button>
            <Button onClick={this.onReceivedHide.bind(this)}><FontAwesome name='close' />&nbsp;ยกเลิกรายการ</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }

  render() {
    let { loading,showSaveEror} = this.state
    return (
      <Box loading={loading}>
        <Box.Header className='text-center'>
          <Box.Title>
            ใบสำคัญจ่ายเงินสดย่อย {this.state.pettycashNo}
          </Box.Title>
          <Box.Tools>
            <Button className='bg-maroon'
              onClick={this.onPrintClick.bind(this)}
            >
              <FontAwesome name='print' />&nbsp;พิมพ์เอกสาร
            </Button>
          </Box.Tools>
        </Box.Header>
        <Box.Body>
          <br/>
          {this.renderHeaderRow()}
          {this.renderTable()}
          {this.renderNewItemButton()}
          {this.renderRemark()}                    
        </Box.Body>
        <Box.Footer>
          <ButtonToolbar className='pull-right'>
            <Button bsStyle='primary' onClick={this.onSaveClick.bind(this)}><FontAwesome name='save' />&nbsp;บันทึก</Button>
            <Button onClick={this.onCloseClick.bind(this)}><FontAwesome name='close' />&nbsp;ปิดเอกสาร</Button>
          </ButtonToolbar>
        </Box.Footer>
        <ConfirmPopup show={showSaveEror} title='เกิดช้อผิดพลาด'
          confirmTitle='ลองบันทึกใหม่' cancelTitle='ยกเลิก' message='เกิดข้อผิดพลาดในการบันทึกข้อมูล กรุณาลองใหม่'
          onConfirm={this.onSaveErrorConfirm.bind(this)}
          onHide={() => { this.setState({ showSaveEror: false }) }}
        />
        <SWTNewCustomerModal
          show={this.state.show}
          onHide={()=>{this.setState({show:false})}}
          onSelect={this.onCustomerSelect.bind(this)}
        />
        <NotificationSystem ref="notificationSystem" /> 
        {this.renderReceivedModal()}
      </Box>
    )
  }
}

PettyCashDoc.defaultProps = {
  pettycashNo:''
}

export default PettyCashDoc;





// WEBPACK FOOTER //
// ./src/view/cashflow/PettyCashDoc.js